import { Component } from '@angular/core';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Annulus } from 'app/modules/equipment-registration/model/annulus.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-annulus-a',
  templateUrl: './annulus-a.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./annulus-a.component.scss']
})
export class AnnulusAComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public annulusA: Annulus = new Annulus();
  public tempAnnulusA: Annulus = new Annulus();
  public isReplace: boolean = true;
  public disabledToggle: boolean = true;

  constructor(
    private equipmentServices: EquipRegistrationServices,
  ) { }

  ngOnInit() {
    this.initializeAnnulusForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return;

      if (wellEquipment?.annulusA) {
        this.annulusA = new Annulus(wellEquipment?.annulusA);
      } else {
        this.initializeAnnulusForm()
      }

      this.handleFormValue()
      this.annulusA.wellStringId = wellEquipment.wellStringId
      this.tempAnnulusA.wellStringId = wellEquipment.wellStringId
      this.isReplace = !wellEquipment?.annulusA;
      this.disabledToggle = !wellEquipment?.annulusA;
    })
  }

  private handleFormValue() {
    if (!this.annulusA.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    this.tempAnnulusA = new Annulus(this.annulusA)
  }

  private initializeAnnulusForm(): void {
    this.annulusA.reset()
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('PCV').subscribe(id => {
      this.annulusA.mdSceValveTypeId = this.tempAnnulusA.mdSceValveTypeId = id
    })
  }

  disabledSave(): boolean {
    return !this.annulusA.wellStringId && !this.annulusA.mdSceValveTypeId || isFormChange(this.annulusA,this.tempAnnulusA)
  }

  save() {
      onTypeChange(this.annulusA)


    const operation = this.isReplace ?
      this.equipmentServices.addSceWellhead(this.annulusA) :
      this.equipmentServices.updateSceWellhead(this.annulusA);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.annulusA.wellStringId).subscribe();
      }
    });
  }

  


}